import { memo } from 'react';
import { useParams } from 'react-router-dom';

import { useJourney } from 'api/journeys/hooks';
import { ACTION_TYPES } from 'ui/actions/action-config';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

import { JourneyStart } from './common';

const ACTION_TYPE = ACTION_TYPES.journey_start;

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  const { journeyId = '' } = useParams();
  const journeyQuery = useJourney(journeyId);

  if (!journeyQuery.isSuccess) {
    return null;
  }

  return (
    <NodeContainer hideTargetHandle node={node} disableClick>
      <JourneyStart node={node} />
    </NodeContainer>
  );
});
